/*! Bloom Cart UI — NEW MOV JSON ONLY, robust vendor match (exact OR slug) */
/* bloom-cart.js */
document.addEventListener('DOMContentLoaded', () => {
  const mount = document.getElementById('bloom-cart');
  if (!mount) return;

  let cfg = {
    vendorByKey: {},
    vendorBySlug: {},
    globalMovCents: 0,
    customerMovCents: null,
    currency: 'auto',
    showOriginalCartTable: false,
    checkoutRestoreDelayMs: 3000,
    debug: false,
    freeGiftAutoAdd: true,
    shopId: null,
    discountEndpoint: 'https://dev.bloomandgrowgroup.com/index.php?route=bloom/discount/getDiscounts',
    customerMovEndpoint: 'https://dev.bloomandgrowgroup.com/index.php?route=bloom/discount/getCustomerMov',
    customerId: null,
    cartUpdatingImage: 'https://dev.bloomandgrowgroup.com/assets/image/loading.gif',
    loadingImage: 'https://dev.bloomandgrowgroup.com/assets/image/loading_big.gif',
    checkoutLoadingImage: 'https://dev.bloomandgrowgroup.com/assets/image/loading.gif',
  };

  try {
    const dataCfg = mount.getAttribute('data-config');
    if (dataCfg) Object.assign(cfg, JSON.parse(dataCfg));
  } catch (e) {
    console.warn('[bloom-cart] Invalid data-config JSON', e);
  }

  const nativeCartEls = () =>
    Array.from(document.querySelectorAll('[data-cart-form], form[action="/cart"], .cart__items'));

  const setNativeCartVisible = (visible) =>
    nativeCartEls().forEach((el) => {
      el.style.display = visible ? '' : 'none';
    });

  setNativeCartVisible(true);

  const slug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

  const fmtMoney = (cents) => {
    try {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    } catch (_) {}

    return (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const symbolFor = (code) =>
    (
      {
        USD: '$',
        CAD: '$',
        AUD: '$',
        NZD: '$',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        SGD: 'S$',
        MYR: 'RM',
        IDR: 'Rp',
        JPY: '¥',
      }[code] || ''
    );

  const withSymbol = (cents) =>
    cfg.currency === 'auto' ? fmtMoney(cents) : `${symbolFor(cfg.currency)}${fmtMoney(cents)}`;

  const escapeHtml = (s) =>
    s == null
      ? ''
      : String(s)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');

  const debounce = (fn, wait = 300) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), wait);
    };
  };

  const LS_KEY_CART_STASH = 'bloom_checkout_and_retain_v1';
  const STASH_TTL_MS = 1000 * 60 * 60 * 6;

  const saveToLS = (k, v) => {
    try {
      localStorage.setItem(k, JSON.stringify(v));
    } catch {}
  };

  const readFromLS = (k) => {
    try {
      const v = localStorage.getItem(k);
      return v ? JSON.parse(v) : null;
    } catch {
      return null;
    }
  };

  const removeLS = (k) => {
    try {
      localStorage.removeItem(k);
    } catch {}
  };

  let CART = null;
  let VENDOR_NOTES = {};
  let SELECTED = {};
  let LAST_READY = {};
  let HAS_PAYMENT_TERMS = null;
  let DISCOUNTS_CACHE = null;
  let DISCOUNTS_PROMISE = null;
  let MANAGED_FREE_GIFT_VARIANT_IDS = new Set();
  const lock = { busy: false };

  const css = `
  .bloom-wrap{font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;max-width:1000px;margin:0 auto;padding:12px}
  .bloom-heading{font-size:28px;line-height:1.2;font-weight:700;margin:4px 0 12px}
  .cart-action{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap}
  .cart-empty-link{font-size:14px;text-decoration:underline;cursor:pointer;color:#111827}
  .cart-empty-link:hover{opacity:.8}
  .bloom-card{background:#fff;border:1px solid #e5e7eb;border-radius:8px;box-shadow:0 1px 2px rgba(0,0,0,.04);padding:16px;margin-bottom:16px}
  .bloom-vendor-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;gap:12px;border-bottom:1px solid #e5e7eb;padding-bottom:10px}
  .bloom-vendor-head h3{font-size:18px;margin:0}
  .mov-badge-over{font-size:12px;line-height:1;background:#d1e7dd;border:1px solid #badbcc;color:#0f5132;padding:6px 10px;border-radius:9999px;white-space:nowrap}
  .mov-badge-under{font-size:12px;line-height:1;background:#f8d7da;border:1px solid #f5c2c7;color:#842029;padding:6px 10px;border-radius:9999px;white-space:nowrap}
  .bloom-vendor-table{width:100%;border-collapse:separate;border-spacing:0 0}
  .bloom-vendor-table td{padding:0 0 10px 0;border:none}
  .vh-check,.vh-logo{vertical-align:middle;text-align:center}
  .vh-check{width:40px;padding-right:20px}
  .vh-logo{width:80px;padding-right:20px}
  .vendor-checkbox{width:20px;height:20px;accent-color:#111827;cursor:pointer;display:inline-block}
  .vendor-checkbox[disabled]{opacity:.5;cursor:not-allowed}
  .vendor-logo{width:60px;height:60px;border-radius:50%;object-fit:contain;background:#fff;border:1px solid #e5e7eb;display:block;margin:0 auto}
  .bloom-item{display:grid;grid-template-columns:72px 1fr auto;gap:12px;align-items:center;padding:10px 0;border-top:1px dashed #e5e7eb}
  .bloom-item:first-of-type{border-top:none}
  .bloom-thumb img{width:72px;height:72px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb}
  .bloom-title{font-size:14px;margin:0 0 6px}
  .bloom-price{font-size:12px;color:#4b5563}
  .bloom-discount-msg{margin-top:4px;font-size:12px;font-weight:600;color:#0f5132}
  .bloom-qty{display:flex;align-items:center;gap:6px;margin-top:6px}
  .bloom-qty button{border:1px solid #d1d5db;background:#f9fafb;border-radius:8px;padding:6px 10px;cursor:pointer}
  .bloom-qty input{width:56px;text-align:center;border:1px solid #d1d5db;border-radius:8px;padding:6px}
  .bloom-remove{font-size:12px;color:#b91c1c;cursor:pointer;margin-left:10px}
  .bloom-subtot{display:flex;justify-content:space-between;align-items:center;margin-top:10px;font-weight:600}
  .bloom-note textarea{width:100%;min-height:60px;border:1px solid #d1d5db;border-radius:8px;padding:8px;resize:vertical}
  .bloom-banner{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412;padding:8px 10px;border-radius:10px;font-size:12px;margin-top:8px}
  .bloom-main-cta{position:sticky;bottom:0;background:#ffffffeb;backdrop-filter:saturate(1.8) blur(6px);border-top:1px solid #e5e7eb;padding:12px;margin-top:12px}
  .bloom-payment-term-msg{padding:12px;font-size:14px;font-weight:600;border:1px solid #facb8d;border-radius:8px;background:#fef7e9;}
  .bloom-cta-row{display:flex;gap:10px;align-items:center;justify-content:space-between;flex-wrap:wrap}
  .btn{display:inline-flex;align-items:center;justify-content:center;border-radius:9999px;padding:10px 16px;border:1px solid #111827;background:#111827;color:#fff;cursor:pointer}
  .btn[disabled]{opacity:.5;cursor:not-allowed}
  .busy{opacity:.6;pointer-events:none}
  .bloom-loading-wrap{display:flex;align-items:center;justify-content:center;min-height:340px}
  .bloom-loading-wrap img{max-width:260px;height:auto;display:block}
  .btn.loading{opacity:.8;pointer-events:none}
  .btn .btn-spinner{display:inline-block;vertical-align:middle;width:20px;height:20px}
  #bloom-checkout.btn.loading{width:180px}
  #bloom-checkout.btn.loading .btn-spinner{width:20px;height:20px}
  .bloom-cart-busy-overlay{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.35);z-index:2147483000}
  .bloom-cart-busy-overlay img{width:30px;height:30px;display:block}
  .bloom-inc{color:#6b7280;font-weight:600}
  .bloom-orig{color:#9ca3af;font-weight:600;text-decoration:line-through;margin-right:6px}
  .bloom-now{color:#4b5563;font-weight:600}
  .bloom-msg{display:none;margin:0 0 12px 0;padding:10px 12px;border-radius:10px;font-size:13px;border:1px solid transparent}
  .bloom-msg.show{display:block}
  .bloom-msg.info{background:#eff6ff;border-color:#bfdbfe;color:#1e3a8a}
  .bloom-msg.warn{background:#fff7ed;border-color:#fed7aa;color:#9a3412}
  .bloom-msg.error{background:#fef2f2;border-color:#fecaca;color:#991b1b}
  `;

  const setBusyOverlay = (show) => {
    let overlay = document.getElementById('bloom-cart-busy-overlay');

    if (show && !overlay) {
      overlay = document.createElement('div');
      overlay.id = 'bloom-cart-busy-overlay';
      overlay.className = 'bloom-cart-busy-overlay';
      overlay.innerHTML = `<img src="${encodeURI(cfg.cartUpdatingImage)}" alt="Updating cart..." />`;
      document.body.appendChild(overlay);
    }

    if (overlay) overlay.style.display = show ? 'flex' : 'none';
  };

  const setBusy = (b) => {
    lock.busy = b;
    document.querySelector('.bloom-wrap')?.classList.toggle('busy', !!b);
    setBusyOverlay(!!b);
  };

  const isReady = (g) => g.movCents <= 0 || g.subtotalCents >= g.movCents;

  const setMessage = (text, type = 'warn', ttlMs = 3500) => {
    const el = document.getElementById('bloom-msg');
    if (!el) return;

    el.textContent = text || '';
    el.classList.remove('info', 'warn', 'error', 'show');
    el.classList.add(type);

    if (text) el.classList.add('show');

    if (ttlMs > 0 && text) {
      clearTimeout(setMessage._t);
      setMessage._t = setTimeout(() => {
        el.classList.remove('show');
        el.textContent = '';
      }, ttlMs);
    }
  };

  const showLoading = () => {
    if (!cfg.showOriginalCartTable) setNativeCartVisible(false);

    mount.innerHTML = `
      <style>${css}</style>
      <div class="bloom-wrap">
        <div class="cart-action">
          <h2 class="bloom-heading">Your Cart</h2>
          <a href="#" id="bloom-empty-cart" class="cart-empty-link">Empty Cart</a>
        </div>
        <div class="bloom-card">
          <div class="bloom-loading-wrap">
            <img src="${encodeURI(cfg.loadingImage)}" alt="Loading your cart..." />
          </div>
        </div>
      </div>
    `;
  };

  (function hydrateVendorMeta() {
    try {
      const el = document.getElementById('shop-movs');
      if (!el) return;

      let raw = (el.textContent || '').trim();
      if (!raw) return;

      let parsed = JSON.parse(raw);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      if (parsed?.value && typeof parsed.value === 'object') parsed = parsed.value;

      const byKey = {};
      const bySlug = {};

      for (const [keyRaw, obj] of Object.entries(parsed)) {
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) continue;

        const mov = Number(obj.mov);
        if (!Number.isFinite(mov)) continue;

        const key = String(keyRaw || '').trim();
        const movCents = Math.round(mov * 100);
        const niceName = String(obj.vendor_nice_name || key).trim();
        const logoUrl = String(obj.vendor_logo_url || '').trim();
        const slugKey = slug(key);

        const meta = { key, slugKey, movCents, niceName, logoUrl };
        byKey[key] = meta;
        bySlug[slugKey] = meta;
      }

      cfg.vendorByKey = byKey;
      cfg.vendorBySlug = bySlug;

      if (cfg.debug) console.log('[bloom-cart] MOV meta keys:', Object.keys(byKey));
    } catch (e) {
      console.warn('[bloom-cart] Failed to parse vendor_app_mov (new shape)', e);
    }
  })();

  /**
   * Read a MOV metafield out of an inline JSON tag and return it in cents.
   *
   * Returns null — meaning "not defined" — when the element is missing, empty,
   * or holds a non-numeric value. A value of 0 is NOT null: it is a deliberate
   * "no minimum" and must be able to override a non-zero default.
   */
  const readMovCents = (elementId) => {
    const el = document.getElementById(elementId);
    if (!el) return null;

    const raw = (el.textContent || '').trim();
    if (!raw || raw === 'null' || raw === '""' || raw === "''") return null;

    let val;

    try {
      val = JSON.parse(raw);
    } catch {
      val = raw;
    }

    // Depending on the metafield type and how the Liquid renders it, the value
    // can arrive bare (500), wrapped ({"value": 500}), or — for a money-type
    // metafield — as {"amount": "500.0", "currency_code": "NZD"}.
    if (val && typeof val === 'object' && !Array.isArray(val)) {
      val = val.value !== undefined ? val.value : val.amount;
    }
    if (val && typeof val === 'object' && !Array.isArray(val)) {
      val = val.amount !== undefined ? val.amount : null;
    }
    if (val === null || val === undefined || val === '') return null;

    const num = parseFloat(val);
    if (!Number.isFinite(num) || num < 0) return null;

    return Math.round(num * 100);
  };

  (function hydrateGlobalMOV() {
    try {
      // Shop-wide default: custom.global_mov
      const shopCents = readMovCents('global-mov');
      if (shopCents !== null) cfg.globalMovCents = shopCents;

      // Per-customer override: customer.metafields.custom.mov wins over the
      // shop-wide value whenever it is defined. Can also be supplied in cents
      // via the mount's data-config as `customerMovCents`.
      let customerCents = readMovCents('customer-mov');

      if (customerCents === null && cfg.customerMovCents !== null && cfg.customerMovCents !== undefined) {
        const fromConfig = Number(cfg.customerMovCents);
        if (Number.isFinite(fromConfig) && fromConfig >= 0) customerCents = Math.round(fromConfig);
      }

      cfg.customerMovCents = customerCents;
      if (customerCents !== null) cfg.globalMovCents = customerCents;

      if (cfg.debug) {
        const tag = document.getElementById('customer-mov');

        let why;
        if (customerCents !== null) why = 'applied';
        else if (!tag) why = 'NOT APPLIED — no #customer-mov element on the page (add the Liquid tag)';
        else why = `NOT APPLIED — #customer-mov is present but empty/unreadable, raw = ${JSON.stringify((tag.textContent || '').trim())}`;

        console.log(
          '[bloom-cart] MOV — shop global:', shopCents,
          '| customer override:', customerCents,
          '| using:', cfg.globalMovCents,
          '|', why
        );
      }
    } catch (e) {
      console.warn('[bloom-cart] Failed to parse MOV metafields', e);
    }
  })();

  const safeJson = async (res) => {
    const text = await res.text();

    try {
      return text ? JSON.parse(text) : null;
    } catch {
      return { __raw: text };
    }
  };

  // Shopify storefronts can be mounted below a locale prefix (for example /en-nz/).
  // Always use Shopify's published routes root instead of assuming the shop lives at `/`.
  const shopifyCartUrl = (endpoint) => {
    const routesRoot = String(window.Shopify?.routes?.root || '/');
    const normalizedRoot = routesRoot.endsWith('/') ? routesRoot : `${routesRoot}/`;
    return `${normalizedRoot}${String(endpoint || '').replace(/^\/+/, '')}`;
  };

  const shopifyPost = async (url, bodyObj) => {
    const res = await fetch(shopifyCartUrl(url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: bodyObj ? JSON.stringify(bodyObj) : undefined,
    });

    const data = await safeJson(res);

    if (!res.ok) {
      const msg = (data && (data.description || data.message)) || `Request failed (${res.status})`;
      const err = new Error(msg);
      err.status = res.status;
      err.data = data;
      throw err;
    }

    return data;
  };

  const fetchCart = async () => {
    const res = await fetch(shopifyCartUrl('cart.js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!res.ok) throw new Error(`Failed to fetch cart (${res.status})`);

    const data = await safeJson(res);
    if (!data || !Array.isArray(data.items)) {
      const responseType = res.headers.get('content-type') || 'unknown content type';
      throw new Error(`Cart endpoint returned an invalid response (${responseType})`);
    }

    return data;
  };

  const changeLine = async (id, quantity) => shopifyPost('cart/change.js', { id, quantity });
  const changeLineNumber = async (line, quantity) => shopifyPost('cart/change.js', { line, quantity });
  const clearCart = async () => shopifyPost('cart/clear.js');

  const addItems = async (items) => {
    if (!items?.length) return null;
    return shopifyPost('cart/add.js', { items });
  };

  const saveVendorNotes = async (map) =>
    shopifyPost('cart/update.js', { attributes: { vendorNotes: JSON.stringify(map) } });

  const SHOP_IDS_BY_DOMAIN = {
    'bloomconnectnz.myshopify.com': '42102259871',
    'bloomconnect.myshopify.com': '35012608137',
    'bloom-connect-sg.myshopify.com': '44068798624',
    'bloomconnecthk.myshopify.com': '49541087392',
    'bloomconnectmy.myshopify.com': '48475504790',
    'bloomconnectid.myshopify.com': '46777794714',
    'bubblefamily.myshopify.com': '76829098301',
    'the-stork-nest.myshopify.com': '18044105',
    'babycentralhk.myshopify.com': '52683899074',
    'babycentralsg.myshopify.com': '69228822844',
    'bloomconnecttest.myshopify.com': '59668267140',
    'dev01-bloom-connect.myshopify.com': '84204421440',
    'dev02-bloom-connect.myshopify.com': '66638577877',
  };

  const toPositiveInt = (value, fallback = 0) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  const normalizeVariantId = (value) => {
    if (value == null) return '';

    if (typeof value === 'object') {
      value = value.id || value.variant_id || value.admin_graphql_api_id || '';
    }

    const raw = String(value).trim();
    const match = raw.match(/(\d+)$/);
    return match ? match[1] : raw;
  };

  const normalizeVariantIds = (items) => {
    if (!Array.isArray(items)) return [];
    return items.map(normalizeVariantId).filter(Boolean);
  };

  const getShopIdForDiscounts = () => {
    const explicit =
      cfg.shopId ||
      cfg.shop_id ||
      mount.dataset.shopId ||
      mount.getAttribute('data-shop-id') ||
      window.BLOOM_SHOP_ID ||
      window.bloomShopId;

    if (explicit) return String(explicit).trim();

    const shopDomain = String(window.Shopify?.shop || '').trim().toLowerCase();
    return SHOP_IDS_BY_DOMAIN[shopDomain] || '';
  };

  const fetchConfiguredDiscounts = async () => {
    if (DISCOUNTS_CACHE) return DISCOUNTS_CACHE;
    if (DISCOUNTS_PROMISE) return DISCOUNTS_PROMISE;

    const shopId = getShopIdForDiscounts();

    if (!shopId) {
      if (cfg.debug) console.warn('[bloom-cart] No shop id available for discount lookup');
      DISCOUNTS_CACHE = [];
      return DISCOUNTS_CACHE;
    }

    DISCOUNTS_PROMISE = (async () => {
      const url = new URL(cfg.discountEndpoint, window.location.origin);
      url.searchParams.set('shop_id', shopId);

      const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });

      if (!res.ok) throw new Error(`Failed to fetch discounts (${res.status})`);

      const data = await res.json();
      DISCOUNTS_CACHE = Array.isArray(data) ? data : [];
      return DISCOUNTS_CACHE;
    })();

    try {
      return await DISCOUNTS_PROMISE;
    } finally {
      DISCOUNTS_PROMISE = null;
    }
  };

  /**
   * The logged-in customer's id. Shopify puts this on every storefront page, so
   * this works with no theme change; an explicit value from data-config or a
   * data-customer-id attribute wins if the theme does supply one.
   * Returns '' for a logged-out visitor.
   */
  const getCustomerIdForMov = () => {
    const explicit =
      cfg.customerId ||
      mount.dataset.customerId ||
      mount.getAttribute('data-customer-id') ||
      window.BLOOM_CUSTOMER_ID;

    if (explicit) {
      const digits = String(explicit).match(/(\d+)\s*$/);
      if (digits) return digits[1];
    }

    const fromAnalytics = window.ShopifyAnalytics?.meta?.page?.customerId;
    if (fromAnalytics) return String(fromAnalytics);

    const fromSt = window.__st?.cid;
    if (fromSt) return String(fromSt);

    return '';
  };

  /**
   * Fetch customer.metafields.custom.mov from the backend and let it override
   * the shop-wide global MOV. Never throws — any failure leaves the global MOV
   * in place, which is the safe default.
   *
   * Skipped entirely when the value already came from the #customer-mov Liquid
   * tag or from data-config, so a theme that does print it pays no round trip.
   */
  const applyCustomerMovFromApi = async () => {
    if (cfg.customerMovCents !== null) return;
    if (!cfg.customerMovEndpoint) return;

    const customerId = getCustomerIdForMov();

    if (!customerId) {
      if (cfg.debug) console.log('[bloom-cart] MOV — no customer id on page (logged out?); keeping global MOV');
      return;
    }

    const shopId = getShopIdForDiscounts();

    if (!shopId) {
      if (cfg.debug) console.warn('[bloom-cart] MOV — no shop id available for customer MOV lookup');
      return;
    }

    try {
      const url = new URL(cfg.customerMovEndpoint, window.location.origin);
      url.searchParams.set('shop_id', shopId);
      url.searchParams.set('customer_id', customerId);

      const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error(`Request failed (${res.status})`);

      const data = await res.json();
      if (data?.error) throw new Error(data.error);

      // An unset metafield comes back as null. Guard before Number(), because
      // Number(null) is 0 — which would read as "no minimum" and wipe the MOV
      // instead of falling back to the shop-wide value.
      const rawCents = data?.mov_cents;

      if (rawCents === null || rawCents === undefined || rawCents === '') {
        if (cfg.debug) console.log('[bloom-cart] MOV — customer', customerId, 'has no custom.mov; keeping global MOV');
        return;
      }

      const cents = Number(rawCents);

      if (!Number.isFinite(cents) || cents < 0) {
        if (cfg.debug) console.warn('[bloom-cart] MOV — unusable mov_cents from API:', rawCents, '; keeping global MOV');
        return;
      }

      cfg.customerMovCents = Math.round(cents);
      cfg.globalMovCents = cfg.customerMovCents;

      if (cfg.debug) {
        console.log('[bloom-cart] MOV — customer override from API:', cfg.customerMovCents, '(customer', customerId + ')');
      }
    } catch (e) {
      console.warn('[bloom-cart] Customer MOV lookup failed; using global MOV', e);
    }
  };

  const freeGiftVariantIdForDiscount = (discount) => {
    const fromVariants = normalizeVariantIds(discount?.free_variant_ids || []);
    if (fromVariants.length) return fromVariants[0];

    const fromProducts = normalizeVariantIds(discount?.free_products || []);
    return fromProducts[0] || '';
  };

  const requiredQtyForDiscount = (discount) => {
    const byType = discount?.free_type === 'collection' ? discount?.collection_qty : discount?.product_qty;
    return toPositiveInt(byType, toPositiveInt(discount?.product_qty, toPositiveInt(discount?.collection_qty, 1)));
  };

  const freeQtyForDiscount = (discount) =>
    toPositiveInt(discount?.free_qty, toPositiveInt(discount?.quantity, 1));

  const desiredFreeQtyForDiscount = (discount, qualifyingQty, requiredQty) => {
    if (qualifyingQty < requiredQty) return 0;

    const minimumFreeQty = freeQtyForDiscount(discount);
    return minimumFreeQty + Math.max(0, qualifyingQty - requiredQty);
  };

  const cartQtyForVariantSet = (variantIds, excludedVariantIds = new Set()) => {
    const ids = new Set(variantIds);

    return (CART?.items || []).reduce((total, item) => {
      const variantId = normalizeVariantId(item.variant_id);
      if (!ids.has(variantId) || excludedVariantIds.has(variantId)) return total;
      return total + (Number(item.quantity) || 0);
    }, 0);
  };

  const reconcileFreeGifts = async () => {
    if (!cfg.freeGiftAutoAdd || !CART?.items?.length) return false;

    let discounts = [];

    try {
      discounts = await fetchConfiguredDiscounts();
    } catch (e) {
      console.warn('[bloom-cart] Discount lookup failed; skipping free gift auto-add', e);
      return false;
    }

    const desiredByVariant = new Map();
    const managedGiftVariantIds = new Set();

    for (const discount of discounts) {
      if (!discount || discount.discount_type !== 'free') continue;

      const freeVariantId = freeGiftVariantIdForDiscount(discount);
      const qualifierVariantIds = normalizeVariantIds(discount.variant_ids || []);

      if (!freeVariantId || !qualifierVariantIds.length) continue;

      const excludedGiftIds = new Set(normalizeVariantIds(discount.free_variant_ids || [freeVariantId]));
      excludedGiftIds.forEach((variantId) => managedGiftVariantIds.add(variantId));

      const qualifyingQty = cartQtyForVariantSet(qualifierVariantIds, excludedGiftIds);
      const requiredQty = requiredQtyForDiscount(discount);
      const desiredQty = desiredFreeQtyForDiscount(discount, qualifyingQty, requiredQty);

      desiredByVariant.set(freeVariantId, Math.max(desiredByVariant.get(freeVariantId) || 0, desiredQty));
    }

    MANAGED_FREE_GIFT_VARIANT_IDS = managedGiftVariantIds;

    if (!managedGiftVariantIds.size) return false;

    let changed = false;

    for (const variantId of managedGiftVariantIds) {
      const desiredQty = desiredByVariant.get(variantId) || 0;
      const giftLines = (CART.items || [])
        .map((item, index) => ({ item, line: index + 1 }))
        .filter(({ item }) => normalizeVariantId(item.variant_id) === variantId);
      const currentQty = giftLines.reduce((sum, { item }) => sum + (Number(item.quantity) || 0), 0);

      if (currentQty === desiredQty) continue;

      if (desiredQty <= 0) {
        for (const { line } of [...giftLines].sort((a, b) => b.line - a.line)) {
          await changeLineNumber(line, 0);
        }

        changed = true;
        CART = await fetchCart();
        continue;
      }

      if (!giftLines.length) {
        await addItems([{ id: variantId, quantity: desiredQty }]);
        changed = true;
        CART = await fetchCart();
        continue;
      }

      const [primaryLine, ...extraLines] = giftLines;

      for (const { line } of [...extraLines].sort((a, b) => b.line - a.line)) {
        await changeLineNumber(line, 0);
      }

      await changeLineNumber(primaryLine.line, desiredQty);

      changed = true;
      CART = await fetchCart();
    }

    return changed;
  };

  const FALLBACK_VENDOR_DISPLAY = 'Bloom & Grow';
  const FALLBACK_LOGO = 'https://bloomandgrowgroup.com/wp-content/uploads/2021/06/BG-logo_r.png';

  const isManagedFreeGiftLine = (item) =>
    MANAGED_FREE_GIFT_VARIANT_IDS.has(normalizeVariantId(item?.variant_id));

  const isZeroPricedLine = (item) => {
    const quantity = Number(item?.quantity) || 0;
    const lineCents =
      Number(item?.final_line_price ?? item?.line_price ?? Number(item?.price || 0) * quantity) || 0;
    const unitCents = Number(item?.final_price ?? item?.price) || 0;

    return lineCents === 0 || unitCents === 0;
  };

  const isDisplayFreeGiftLine = (item) =>
    !!item?._bloomManagedFreeGift || isManagedFreeGiftLine(item);

  const getDisplayItems = (items = []) => {
    const output = [];
    const managedByVariant = new Map();
    const zeroPricedVariantCounts = {};

    for (const item of items) {
      const variantId = normalizeVariantId(item.variant_id);
      if (!variantId || !isZeroPricedLine(item)) continue;
      zeroPricedVariantCounts[variantId] = (zeroPricedVariantCounts[variantId] || 0) + 1;
    }

    for (const item of items) {
      const variantId = normalizeVariantId(item.variant_id);
      const shouldAggregateFreeLine =
        isManagedFreeGiftLine(item) ||
        (isZeroPricedLine(item) && zeroPricedVariantCounts[variantId] > 1);

      if (!shouldAggregateFreeLine) {
        output.push(item);
        continue;
      }

      const existing = managedByVariant.get(variantId);
      const quantity = Number(item.quantity) || 0;

      if (existing) {
        existing.quantity += quantity;
        existing._bloomDiscountMessages = [
          ...new Set([
            ...(existing._bloomDiscountMessages || []),
            ...getCartLineDiscountMessages(item),
          ]),
        ];
        existing.original_line_price =
          (Number(existing.original_line_price) || 0) +
          (Number(item.original_line_price ?? Number(item.original_price || item.price || 0) * quantity) || 0);
        continue;
      }

      const displayItem = {
        ...item,
        quantity,
        final_price: 0,
        final_line_price: 0,
        line_price: 0,
        _bloomManagedFreeGift: true,
        _bloomDiscountMessages: getCartLineDiscountMessages(item),
      };

      managedByVariant.set(variantId, displayItem);
      output.push(displayItem);
    }

    return output;
  };

  const metaForVendor = (cartVendor) => {
    const v = String(cartVendor || '').trim();
    if (cfg.vendorByKey[v]) return cfg.vendorByKey[v];

    const sv = slug(v);
    return cfg.vendorBySlug[sv] || null;
  };

  const groupByVendor = (items = []) => {
    const rawBuckets = {};

    getDisplayItems(items).forEach((it) => {
      const rv = String(it.vendor || '').trim();

      if (!rawBuckets[rv]) {
        rawBuckets[rv] = { rawVendor: rv, items: [], subtotalCents: 0 };
      }

      const lineCents = isDisplayFreeGiftLine(it)
        ? 0
        : Number(it.final_line_price ?? it.line_price ?? Number(it.price) * Number(it.quantity)) || 0;

      rawBuckets[rv].items.push(it);
      rawBuckets[rv].subtotalCents += lineCents;
    });

    const byGroup = {};

    const fallback = {
      id: FALLBACK_VENDOR_DISPLAY,
      displayName: FALLBACK_VENDOR_DISPLAY,
      logoUrl: FALLBACK_LOGO,
      movCents: cfg.globalMovCents || 0,
      items: [],
      subtotalCents: 0,
    };

    Object.values(rawBuckets).forEach((bucket) => {
      const meta = metaForVendor(bucket.rawVendor);

      if (meta) {
        if (!byGroup[meta.key]) {
          byGroup[meta.key] = {
            id: meta.key,
            displayName: meta.niceName || meta.key,
            logoUrl: meta.logoUrl || FALLBACK_LOGO,
            movCents: meta.movCents || 0,
            items: [],
            subtotalCents: 0,
          };
        }

        byGroup[meta.key].items.push(...bucket.items);
        byGroup[meta.key].subtotalCents += bucket.subtotalCents;
      } else {
        fallback.items.push(...bucket.items);
        fallback.subtotalCents += bucket.subtotalCents;
      }
    });

    if (fallback.items.length) byGroup[FALLBACK_VENDOR_DISPLAY] = fallback;

    return byGroup;
  };

  const payloadFromLine = (li) => {
    const p = { id: li.variant_id, quantity: li.quantity };

    if (li.properties && Object.keys(li.properties).length) p.properties = li.properties;

    const spId = li.selling_plan_allocation?.selling_plan?.id;
    if (spId) p.selling_plan = spId;

    return p;
  };

  const keyFromPayload = (p) =>
    `${p.id}|${p.selling_plan || ''}|${p.properties ? JSON.stringify(p.properties) : ''}`;

  const arrayToMap = (arr = []) => {
    const m = new Map();

    for (const p of arr) {
      const k = keyFromPayload(p);
      m.set(k, (m.get(k) || 0) + (Number(p.quantity) || 0));
    }

    return m;
  };

  const cartToMap = (cart) => arrayToMap((cart?.items || []).map(payloadFromLine));

  const mapsEqual = (a, b) => a.size === b.size && [...a].every(([k, v]) => b.get(k) === v);

  const setCheckoutLoading = (on) => {
    const btn = document.getElementById('bloom-checkout');
    if (!btn) return;

    if (on) {
      if (!btn.dataset.prevLabel) btn.dataset.prevLabel = btn.textContent || '';
      btn.classList.add('loading');
      btn.disabled = true;
      btn.innerHTML = `<img class="btn-spinner" src="${encodeURI(cfg.checkoutLoadingImage)}" alt="Loading..." />`;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('loading');
      btn.disabled = false;
      btn.innerHTML = btn.dataset.prevLabel || 'Proceed to checkout';
      btn.removeAttribute('aria-busy');
      delete btn.dataset.prevLabel;
    }
  };

  const runRestoreIfAvailable = async () => {
    try {
      const fn = window.restore || window.bloomRestore;

      if (typeof fn === 'function') {
        const maybe = fn();

        if (maybe && typeof maybe.then === 'function') {
          await maybe;
        } else if (cfg.checkoutRestoreDelayMs > 0) {
          await new Promise((r) => setTimeout(r, cfg.checkoutRestoreDelayMs));
        }
      }
    } catch (e) {
      console.warn('[bloom-cart] restore() call failed (continuing)', e);
    }
  };

  const maybeRestoreFromLS = async () => {
    const stash = readFromLS(LS_KEY_CART_STASH);
    if (!stash || (!Array.isArray(stash.checkout) && !Array.isArray(stash.retain))) return;

    const ts = Number(stash.ts || 0);

    if (!ts || Date.now() - ts > STASH_TTL_MS) {
      removeLS(LS_KEY_CART_STASH);
      return;
    }

    const checkoutArr = Array.isArray(stash.checkout) ? stash.checkout : [];
    const theRetainArr = Array.isArray(stash.retain) ? stash.retain : [];
    const targetArr = [...checkoutArr, ...theRetainArr];

    const checkoutMap = arrayToMap(checkoutArr);
    const targetMap = arrayToMap(targetArr);
    const currentMap = cartToMap(CART);
    const currentItemCount = Number(CART?.item_count || 0);

    const baseByKey = new Map();

    for (const p of targetArr) {
      const k = keyFromPayload(p);
      if (!baseByKey.has(k)) baseByKey.set(k, p);
    }

    const buildDiffAdds = () => {
      const adds = [];

      for (const [k, targetQty] of targetMap.entries()) {
        const currQty = currentMap.get(k) || 0;
        const need = targetQty - currQty;

        if (need > 0) {
          const base = baseByKey.get(k);

          adds.push({
            id: base.id,
            quantity: need,
            ...(base.selling_plan ? { selling_plan: base.selling_plan } : {}),
            ...(base.properties ? { properties: base.properties } : {}),
          });
        }
      }

      return adds;
    };

    try {
      if (currentItemCount === 0) {
        removeLS(LS_KEY_CART_STASH);
        return;
      }

      if (mapsEqual(currentMap, checkoutMap)) {
        await clearCart();

        if (targetArr.length) await addItems(targetArr);

        removeLS(LS_KEY_CART_STASH);
        CART = await fetchCart();
        return;
      }

      const adds = buildDiffAdds();

      if (adds.length) await addItems(adds);

      removeLS(LS_KEY_CART_STASH);
      CART = await fetchCart();
    } catch (e) {
      console.warn('[bloom-cart] restore-from-LS failed', e);
    }
  };

  const getCartLineDiscountMessages = (it) => {
    const discountMessages = Array.isArray(it?._bloomDiscountMessages)
      ? [...it._bloomDiscountMessages]
      : [];

    if (Array.isArray(it.line_level_discount_allocations)) {
      it.line_level_discount_allocations.forEach((d) => {
        const title =
          d?.discount_application?.title ||
          d?.discount_application?.description ||
          d?.title ||
          d?.description ||
          '';

        if (title) discountMessages.push(title);
      });
    }

    if (Array.isArray(it.discounts)) {
      it.discounts.forEach((d) => {
        const title = d?.title || d?.description || '';

        if (title) discountMessages.push(title);
      });
    }

    return [...new Set(discountMessages.filter(Boolean))];
  };

  const render = () => {
    if (!CART) return;

    const groups = groupByVendor(CART.items || []);
    const vendors = Object.values(groups);

    vendors.forEach((v) => {
      const ready = isReady(v);
      const prev = LAST_READY[v.id];

      if (!(v.id in SELECTED)) {
        SELECTED[v.id] = ready;
      } else {
        if (!ready && SELECTED[v.id]) SELECTED[v.id] = false;
        if (ready && prev === false) SELECTED[v.id] = true;
      }

      LAST_READY[v.id] = ready;
    });

    Object.keys(SELECTED).forEach((id) => {
      if (!vendors.find((v) => v.id === id)) {
        delete SELECTED[id];
        delete LAST_READY[id];
      }
    });

    const selectedReadyCount = vendors.filter((v) => SELECTED[v.id] && isReady(v)).length;

    const vendorBlocks = vendors
      .map((v) => {
        const ready = isReady(v);
        const checked = ready && !!SELECTED[v.id];
        const badgeClass = ready ? 'mov-badge-over' : 'mov-badge-under';

        const rowsHtml = (v.items || [])
          .map((it, idx) => {
            const img = it.image || it.featured_image?.url;
            const key = it.key;
            const isManagedFreeGift = isDisplayFreeGiftLine(it);

            const unitNowCents = isManagedFreeGift ? 0 : Number(it.final_price ?? it.price) || 0;
            const unitOrigCents = Number(it.original_price ?? it.price) || 0;

            const lineNowCents = isManagedFreeGift
              ? 0
              : Number(it.final_line_price ?? it.line_price ?? Number(it.price) * Number(it.quantity)) || 0;

            const lineOrigCents =
              Number(it.original_line_price ?? unitOrigCents * Number(it.quantity)) || 0;

            const unitHasDiscount = unitOrigCents > unitNowCents;
            const lineHasDiscount = lineOrigCents > lineNowCents;

            const uniqueDiscountMessages = getCartLineDiscountMessages(it);

            const discountMessageHtml = uniqueDiscountMessages.length
              ? `<div class="bloom-discount-msg">${uniqueDiscountMessages.map(escapeHtml).join('<br />')}</div>`
              : '';

            const incRaw = it?.properties?._inc ?? it?.properties?.inc ?? it?.properties?.increment ?? '';
            const moqRaw = it?.properties?._moq ?? it?.properties?.moq ?? it?.properties?.minimum ?? '';

            const inc = parseInt(incRaw, 10);
            const moq = parseInt(moqRaw, 10);

            const hasInc = Number.isFinite(inc) && inc > 1;
            const safeInc = hasInc ? inc : 1;
            const safeMoq = Number.isFinite(moq) && moq > 0 ? moq : 1;

            const leadingCells =
              idx === 0
                ? `
            <td class="vh-check" rowspan="${v.items.length}">
              <input class="vendor-checkbox" type="checkbox"
                     data-vendor-check="${escapeHtml(v.id)}"
                     ${checked ? 'checked' : ''}
                     ${!ready ? 'disabled' : ''}>
            </td>
            <td class="vh-logo" rowspan="${v.items.length}">
              <img class="vendor-logo" src="${v.logoUrl}" alt="${escapeHtml(v.displayName)} logo">
            </td>`
                : '';

            return `
          <tr>
            ${leadingCells}
            <td>
              <div class="bloom-item" data-line="${escapeHtml(key)}">
                <div class="bloom-thumb">${img ? `<img src="${encodeURI(img)}" alt="">` : ''}</div>

                <div>
                  <p class="bloom-title">
                    <a class="bloom-title-link" href="${escapeHtml(it.url || '#')}">
                      ${escapeHtml(it.product_title)}${
                        it.variant_title && it.variant_title !== 'Default Title'
                          ? ` — ${escapeHtml(it.variant_title)}`
                          : ''
                      }
                    </a>
                  </p>

                  <div class="bloom-price">
                    ${hasInc ? `MOQ: ${safeMoq} • Increment: ${safeInc}<br />` : ``}

                    Unit:
                    ${
                      unitHasDiscount
                        ? `<span class="bloom-orig">${withSymbol(unitOrigCents)}</span><span class="bloom-now">${withSymbol(unitNowCents)}</span>`
                        : `<span class="bloom-now">${withSymbol(unitNowCents)}</span>`
                    }
                    •
                    <span class="bloom-inc">
                      Line:
                      ${
                        lineHasDiscount
                          ? `<span class="bloom-orig">${withSymbol(lineOrigCents)}</span><span class="bloom-now">${withSymbol(lineNowCents)}</span>`
                          : `<span class="bloom-now">${withSymbol(lineNowCents)}</span>`
                      }
                    </span>
                  </div>

                  ${discountMessageHtml}

                  <div class="bloom-qty" data-line="${escapeHtml(key)}" data-inc="${safeInc}" data-has-inc="${hasInc ? '1' : '0'}">
                    <button type="button" data-act="dec" ${isManagedFreeGift ? 'disabled' : ''}>−</button>
                    <input type="number" min="0" step="${safeInc}" value="${Number(it.quantity) || 0}" inputmode="numeric" ${isManagedFreeGift ? 'disabled' : ''} />
                    <button type="button" data-act="inc" ${isManagedFreeGift ? 'disabled' : ''}>+</button>
                    ${isManagedFreeGift ? '' : '<span class="bloom-remove" data-act="remove">Remove</span>'}
                  </div>
                </div>

                <div>
                 <span class="bloom-now">${withSymbol(lineNowCents)}</span>
                </div>
              </div>
            </td>
          </tr>`;
          })
          .join('');

        const movBadge = v.movCents ? `<div class="${badgeClass}">MOV: ${withSymbol(v.movCents)}</div>` : ``;

        return `
        <div class="bloom-card" data-vendor="${escapeHtml(v.id)}">
          <div class="bloom-vendor-head">
            <h3>${escapeHtml(v.displayName)}</h3>
            ${movBadge}
          </div>

          <table class="bloom-vendor-table">
            <tbody>${rowsHtml}</tbody>
          </table>

          <div class="bloom-subtot">
            <div>Subtotal for ${escapeHtml(v.displayName)}</div>
            <div>${withSymbol(v.subtotalCents)}</div>
          </div>

          ${
            !ready
              ? `<div class="bloom-banner">Minimum order value for <strong>${escapeHtml(v.displayName)}</strong> is ${withSymbol(v.movCents)}. You’re at ${withSymbol(v.subtotalCents)}.</div>`
              : ''
          }
        </div>`;
      })
      .join('');

    const msgReadyCount = selectedReadyCount;
    const brandsWordReady = msgReadyCount === 1 ? 'brand' : 'brands';
    const verbReady = msgReadyCount === 1 ? 'is' : 'are';

    const checkoutLabel =
      selectedReadyCount > 0 ? `Checkout ${selectedReadyCount} ${brandsWordReady}` : `Proceed to checkout`;

    const checkoutDisabled = selectedReadyCount === 0;

    const hasBloomGrowProducts = vendors.some(
      v => v.id === FALLBACK_VENDOR_DISPLAY
    );

    const hasOtherVendorProducts = vendors.some(
      v => v.id !== FALLBACK_VENDOR_DISPLAY
    );

    // Show warning only when payment terms customer has a mixed cart
    const showPaymentMsg =
      HAS_PAYMENT_TERMS === true &&
      hasBloomGrowProducts &&
      hasOtherVendorProducts;

    mount.innerHTML = `
      <style>${css}</style>
      <div class="bloom-wrap">
        <div class="cart-action">
          <h2 class="bloom-heading">Your Cart</h2>
          <a href="#" id="bloom-empty-cart" class="cart-empty-link">Empty Cart</a>
        </div>

        <div id="bloom-msg" class="bloom-msg warn" role="status" aria-live="polite"></div>

        ${vendorBlocks || `<div class="bloom-card"><p>Your cart is empty.</p></div>`}

        <div class="bloom-main-cta">
          <div class="bloom-cta-row">
            <div class="left">
              <div><strong>${msgReadyCount} ${brandsWordReady} ${verbReady} ready for checkout</strong></div>
            </div>
            <div class="right">
              <button class="btn" id="bloom-checkout" ${checkoutDisabled ? 'disabled' : ''}>${checkoutLabel}</button>
            </div>
          </div>
        </div>

        ${
          showPaymentMsg
            ? `
          <div class="bloom-payment-term-msg">
            Only Bloom & Grow products are available on payment terms kindly checkout separately to use terms
          </div>`
            : ``
        }
      </div>
    `;

    if (!cfg.showOriginalCartTable) setNativeCartVisible(false);

    bindEvents();
  };

  const onQtyClick = async (container, act) => {
    if (lock.busy) return;

    const lineKey = container.getAttribute('data-line');
    const input = container.querySelector('input[type="number"]');

    const hasInc = container.getAttribute('data-has-inc') === '1';
    const inc = Math.max(1, parseInt(container.getAttribute('data-inc') || '1', 10) || 1);

    let next = parseInt(input.value || '0', 10);
    if (!Number.isFinite(next) || next < 0) next = 0;

    const step = hasInc ? inc : 1;

    if (act === 'inc') next += step;
    if (act === 'dec') next = Math.max(0, next - step);

    await doChange(lineKey, next);
  };

  const onQtyInput = debounce(async (inputEl) => {
    if (lock.busy) return;

    const container = inputEl.closest('.bloom-qty');
    const lineKey = container.getAttribute('data-line');

    const hasInc = container.getAttribute('data-has-inc') === '1';
    const inc = Math.max(1, parseInt(container.getAttribute('data-inc') || '1', 10) || 1);

    let next = parseInt(inputEl.value || '0', 10);
    if (!Number.isFinite(next) || next < 0) next = 0;

    if (hasInc && next > 0) {
      next = Math.ceil(next / inc) * inc;
      inputEl.value = String(next);
    }

    await doChange(lineKey, next);
  }, 400);

  const onRemove = async (container) => {
    if (lock.busy) return;

    const lineKey = container.getAttribute('data-line');
    await doChange(lineKey, 0);
  };

  const doChange = async (lineKey, qty) => {
    try {
      setBusy(true);
      setMessage('', 'warn', 0);

      await changeLine(lineKey, qty);

      CART = await fetchCart();

      await reconcileFreeGifts();

      render();
    } catch (e) {
      console.error('[bloom-cart] changeLine failed', e);

      try {
        CART = await fetchCart();
        render();
      } catch (syncErr) {
        console.error('[bloom-cart] failed to refetch cart after error', syncErr);
      }

      const status = e?.status;
      const rawMsg = String(e?.message || '').toLowerCase();

      const looksLikeStockLimit =
        status === 422 ||
        rawMsg.includes('inventory') ||
        rawMsg.includes('available') ||
        rawMsg.includes('cannot add') ||
        rawMsg.includes("can't add") ||
        rawMsg.includes('quantity') ||
        rawMsg.includes('sold out');

      if (looksLikeStockLimit) {
        setMessage('Available stock limit is reached.', 'error', 3500);
      } else {
        setMessage(e?.message || 'Could not update cart. Please try again.', 'error', 4000);
      }
    } finally {
      setBusy(false);
    }
  };

  const bindEvents = () => {
    document.querySelectorAll('.bloom-qty button[data-act]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const act = btn.getAttribute('data-act');
        await onQtyClick(btn.closest('.bloom-qty'), act);
      });
    });

    document.querySelectorAll('.bloom-qty input[type="number"]').forEach((inp) => {
      inp.addEventListener('input', () => onQtyInput(inp));
    });

    document.querySelectorAll('.bloom-remove').forEach((el) => {
      el.addEventListener('click', async () => {
        await onRemove(el.closest('.bloom-qty'));
      });
    });

    document.querySelectorAll('textarea[data-vendor-note]').forEach((ta) => {
      ta.addEventListener('input', () => {
        const id = ta.getAttribute('data-vendor-note');
        VENDOR_NOTES[id] = ta.value;
      });
    });

    document.querySelectorAll('input[data-vendor-check]').forEach((chk) => {
      chk.addEventListener('change', () => {
        const id = chk.getAttribute('data-vendor-check');

        if (chk.disabled) return;

        SELECTED[id] = chk.checked;
        render();
      });
    });

    const emptyCartBtn = document.getElementById('bloom-empty-cart');

    if (emptyCartBtn) {
      emptyCartBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        if (lock.busy) return;

        try {
          setBusy(true);
          setMessage('', 'warn', 0);
          await clearCart();
          removeLS(LS_KEY_CART_STASH);
          CART = await fetchCart();
          render();
        } catch (err) {
          console.error('[bloom-cart] clearCart failed', err);
          setMessage('Failed to empty cart. Please try again.', 'error', 4000);
        } finally {
          setBusy(false);
        }
      });
    }

    const checkoutBtn = document.getElementById('bloom-checkout');

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', async () => {
        if (lock.busy) return;

        const groups = groupByVendor(CART.items || []);
        const vendors = Object.values(groups);

        const readyChecked = new Set(vendors.filter((v) => SELECTED[v.id] && isReady(v)).map((v) => v.id));

        if (!readyChecked.size) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setMessage('Please select at least one brand that meets its MOV to continue.', 'warn', 4500);
          return;
        }

        const selectedIds = Array.from(readyChecked);
        const onlyFallbackSelected = selectedIds.length === 1 && selectedIds[0] === FALLBACK_VENDOR_DISPLAY;

        const hasMetafieldVendorsInCart = (CART.items || []).some((it) => !!metaForVendor((it.vendor || '').trim()));

        const checkoutPayload = [];
        const retainPayload = [];

        for (const it of CART.items || []) {
          const meta = metaForVendor((it.vendor || '').trim());
          const groupId = meta ? meta.key : FALLBACK_VENDOR_DISPLAY;
          const p = payloadFromLine(it);

          if (readyChecked.has(groupId)) checkoutPayload.push(p);
          else retainPayload.push(p);
        }

        setCheckoutLoading(true);

        try {
          lock.busy = true;

          if (onlyFallbackSelected) {
            await runRestoreIfAvailable();
          } else {
            if (hasMetafieldVendorsInCart && typeof window.bloomSuspend === 'function') {
              try {
                await window.bloomSuspend();
              } catch (_e) {}
            }
          }

          try {
            await saveVendorNotes(VENDOR_NOTES);
          } catch {}

          saveToLS(LS_KEY_CART_STASH, {
            checkout: checkoutPayload,
            retain: retainPayload,
            ts: Date.now(),
          });

          await clearCart();

          if (checkoutPayload.length) await addItems(checkoutPayload);

          window.location.assign('/checkout');
        } catch (e) {
          console.error('[bloom-cart] selective checkout failed', e);
          setMessage('Could not prepare your checkout. Please try again.', 'error', 4500);
          setCheckoutLoading(false);
          lock.busy = false;
        }
      });
    }
  };

  (async () => {
    try {
      showLoading();
      lock.busy = true;

      fetchConfiguredDiscounts().catch((e) => {
        if (cfg.debug) console.warn('[bloom-cart] Discount prefetch failed', e);
      });

      // Runs alongside the cart fetches; awaited before the first render so the
      // MOV badge never flashes the shop-wide value first.
      const customerMovReady = applyCustomerMovFromApi();

      CART = await fetchCart();

      await maybeRestoreFromLS();

      CART = await fetchCart();

      try {
        await reconcileFreeGifts();
      } catch (e) {
        console.warn(
          '[bloom-cart] Free-gift reconciliation failed; continuing without updating gifts',
          e
        );

        CART = await fetchCart();
      }

      await customerMovReady;

      render();

      try {
        if (typeof window.hasPaymentTerms === 'function') {
          const resp = await window.hasPaymentTerms();
          HAS_PAYMENT_TERMS = !!(resp && resp.error === '' && resp.hasPaymentTerms === true);
        } else {
          HAS_PAYMENT_TERMS = false;
          console.warn('[bloom-cart] hasPaymentTerms() not found on window');
        }
      } catch (e) {
        HAS_PAYMENT_TERMS = false;
        console.warn('[bloom-cart] hasPaymentTerms() failed', e);
      }

      render();

      if (cfg.debug) {
        const vendorsSeen = [...new Set((CART.items || []).map((i) => String(i.vendor || '').trim()))];
        console.log('[bloom-cart] Product vendors in cart]:', vendorsSeen);
        console.log('[bloom-cart] HAS_PAYMENT_TERMS:', HAS_PAYMENT_TERMS);
      }
    } catch (e) {
      console.error('[bloom-cart] Failed to load cart', e);

      mount.innerHTML = `
        <style>${css}</style>
        <div class="bloom-wrap">
          <div class="cart-action">
            <h2 class="bloom-heading">Your Cart</h2>
            <a href="#" id="bloom-empty-cart" class="cart-empty-link">Empty Cart</a>
          </div>
          <div class="bloom-card"><p>We couldn’t load the custom cart. Showing the default cart instead.</p></div>
        </div>
      `;

      setNativeCartVisible(true);
    } finally {
      lock.busy = false;
    }
  })();
});
